export default "__VITE_ASSET__BaNo8d22__"